<div
  #mainBox
  [class.top-box]="isTopBox"
  [class.bottom-box]="isBottomBox"
  [class.data-recorded-success]="justRecorded"
  [class.data-buffer-active]="addingTargetData"
  class="pointer data-entry-box"
  (click)="clickedBox()"
  (clickOutside)="onClickOutside()"
  [additionalElementRefs]="extraBoxes"
>
  <div
    class="flag no-select"
    [class.flag-all-trials]="remainingTrials <= 0"
    (mousedown)="startLongPress()"
    (mouseup)="endLongPress($event)"
    (mouseleave)="endLongPress($event)"
    (touchstart)="startLongPress()"
    (touchend)="endLongPress($event)"
    (touchcancel)="endLongPress($event)"
  >
    <span *ngIf="!isEditing" class="flag-text"
      >{{ text }}

      <span class="sd-text">{{ target?.DiscriminativeStimulus }}</span>
    </span>

    <span *ngIf="isEditing">{{ sessionValue }}</span>
    <span class="badge badge-right">{{ sessionValue }}</span>
    <span *ngIf="!isEditing && showDayValue" class="badge badge-left">{{
      dayValue + sessionValue
    }}</span>
    <button
      *ngIf="isEditing"
      class="flag-button top-left green"
      (click)="decreaseSessionValue()"
    >
      -
    </button>
    <button
      *ngIf="isEditing"
      class="flag-button bottom-right red"
      (click)="increaseSessionValue()"
    >
      +
    </button>
    <button class="badge-bottom-left" (click)="openDetails($event)">?</button>
    <button
      class="badge-bottom-right"
      (click)="openDetails($event)"
      title="Remaining desired Trials"
      *ngIf="remainingTrials > 0 && !isEditing"
    >
      {{ remainingTrials }}
    </button>
  </div>
  <!-- Cooldown bar: always in DOM to avoid layout jump; visible only when active -->
  <div
    class="data-entry-cooldown-bar"
    [class.data-entry-cooldown-active]="addingTargetData"
    aria-hidden="true"
  >
    <div class="data-entry-cooldown-bar-fill"></div>
  </div>
</div>

@if (detailsOpened) {
<app-target-details
  [target]="target"
  (onCloseDetails)="onCloseDetails()"
  [isPreview]="isPreview"
></app-target-details>
}
